import { Icon } from "../../../components/BaseComponents/Icon";

export const ThirtySecClockIcon = (props) => (
	<Icon viewBox="0 0 134 134" fill="none" {...props}>
		<g filter="url(#a)">
			<circle cx="67" cy="67" r="52" fill="#fff" />
		</g>
		<path
			fill="#FDBA74"
			fillRule="evenodd"
			d="m61.17 20.56.8 6.4-1.43.2-1.03-6.36c.55-.1 1.1-.17 1.66-.24Zm-6.55 1.3 1.7 6.22-1.38.4-1.92-6.15c.52-.17 1.06-.33 1.6-.47Zm-6.3 2.22L50.9 30c-.44.19-.88.39-1.3.6l-2.8-5.83 1.52-.7Zm-5.91 3.1 3.4 5.49c-.42.25-.82.5-1.22.78L41 28.08l1.4-.9Zm-5.42 3.9 4.14 4.96c-.36.3-.73.62-1.08.94l-4.32-4.8 1.26-1.1Zm-4.8 4.65 4.8 4.31-.95 1.09-4.95-4.14c.36-.43.73-.85 1.1-1.26ZM28.09 41l5.36 3.59-.78 1.2-5.49-3.39.9-1.4Zm-3.31 5.8 5.82 2.79-.6 1.3-5.92-2.57.7-1.52ZM22.33 53l6.16 1.93c-.14.45-.28.91-.4 1.38l-6.23-1.7c.15-.55.3-1.08.47-1.61Zm-1.53 6.5 6.37 1.02-.2 1.43-6.4-.8c.06-.55.14-1.1.23-1.65Zm-.59 6.65a47.75 47.75 0 0 0 0 1.68l6.46-.12a41.65 41.65 0 0 1 0-1.45l-6.46-.11Zm.36 6.67 6.4-.8.2 1.43-6.37 1.03c-.09-.55-.17-1.1-.23-1.66Zm1.3 6.55 6.22-1.7c.12.46.26.92.4 1.38l-6.16 1.93-.47-1.6Zm2.21 6.3L30 83.1l.6 1.31-5.82 2.79-.7-1.52Zm3.1 5.91 5.5-3.4c.24.42.5.82.77 1.22L28.1 93c-.31-.46-.61-.93-.9-1.4ZM31.09 97l4.95-4.14.95 1.09-4.8 4.31c-.37-.41-.74-.83-1.1-1.26Zm4.64 4.8 4.32-4.8 1.08.95L37 102.9c-.42-.36-.85-.72-1.26-1.1Zm5.27 4.1 3.6-5.36 1.2.78-3.4 5.49-1.4-.9Zm5.8 3.31 2.8-5.82 1.3.6-2.58 5.92-1.52-.7Zm6.22 2.45 1.92-6.16c.46.14.92.28 1.38.4l-1.7 6.23c-.54-.15-1.07-.3-1.6-.47Zm6.5 1.53 1.02-6.37 1.42.2-.8 6.4c-.55-.06-1.1-.14-1.65-.23Z"
			clipRule="evenodd"
		/>
		<path
			fill="#F97316"
			d="M65.72 20.2a47.66 47.66 0 0 1 18.49 3.4 47.3 47.3 0 0 1 15.7 10.25 46.78 46.78 0 0 1 10.4 15.5 46.4 46.4 0 0 1-11.36 51.7 47.32 47.32 0 0 1-15.97 9.83 47.68 47.68 0 0 1-18.58 2.87l.3-6.55a41.01 41.01 0 0 0 29.72-10.9 39.93 39.93 0 0 0 .81-57.8 40.99 40.99 0 0 0-29.4-11.73l-.1-6.55Z"
		/>
		<path
			fill="#F97316"
			d="M75.12 94.95c-1.15 0-2.03-.33-2.64-.98-.6-.65-.89-1.57-.89-2.76v-8.17c0-1.2.3-2.11.9-2.77.6-.65 1.48-.97 2.63-.97 1.14 0 2.02.32 2.61.97.61.66.91 1.58.91 2.77v1.6h-2.26v-1.76c0-.94-.4-1.41-1.2-1.41-.8 0-1.2.47-1.2 1.41v8.5c0 .93.4 1.4 1.2 1.4.8 0 1.2-.47 1.2-1.4v-2.32h2.26v2.15c0 1.19-.3 2.1-.9 2.76-.6.65-1.48.98-2.62.98ZM63.83 79.51h6.53v2.18h-4.13v4.02h3.29v2.17h-3.3v4.68h4.14v2.17h-6.53V79.5Zm-4.98 15.44c-1.17 0-2.04-.33-2.64-.98-.6-.67-.9-1.62-.9-2.85v-.87h2.27v1.04c0 .99.42 1.48 1.24 1.48.41 0 .71-.11.92-.34.22-.25.32-.64.32-1.18 0-.64-.14-1.2-.43-1.67a7.88 7.88 0 0 0-1.61-1.76 9.75 9.75 0 0 1-2.07-2.35c-.4-.71-.59-1.5-.59-2.4 0-1.2.3-2.12.92-2.77.6-.67 1.5-1 2.65-1s2.01.33 2.6 1c.59.65.89 1.59.89 2.82v.63h-2.27v-.78c0-.52-.1-.9-.3-1.13-.2-.25-.5-.37-.9-.37-.8 0-1.2.49-1.2 1.46 0 .55.15 1.06.44 1.54.3.48.85 1.06 1.64 1.74a8.8 8.8 0 0 1 2.06 2.37c.38.7.57 1.54.57 2.5 0 1.24-.31 2.2-.94 2.87-.6.66-1.5 1-2.67 1Zm17.96-19.78c-2.71 0-4.79-.77-6.23-2.31-1.44-1.54-2.16-3.71-2.16-6.52V47.88c0-2.81.72-4.99 2.16-6.52 1.44-1.54 3.52-2.31 6.23-2.31 2.71 0 4.8.77 6.23 2.3 1.44 1.54 2.16 3.72 2.16 6.53v18.46c0 2.8-.72 4.98-2.16 6.52-1.44 1.54-3.52 2.3-6.23 2.3Zm0-5.02c1.91 0 2.87-1.15 2.87-3.46V47.53c0-2.31-.96-3.46-2.87-3.46-1.9 0-2.86 1.15-2.86 3.46v19.16c0 2.3.95 3.46 2.86 3.46Zm-19.77 5.02c-2.7 0-4.77-.76-6.18-2.26-1.37-1.5-2.06-3.66-2.06-6.47v-2.86h5.23v3.1c0 2.32.95 3.47 2.86 3.47.94 0 1.64-.28 2.11-.85.5-.6.76-1.64.76-3.11v-2.86c0-1.6-.29-2.74-.86-3.41-.57-.7-1.49-1.06-2.76-1.06h-1.86v-5.01h2.01c1.1 0 1.93-.29 2.46-.86.57-.56.86-1.52.86-2.86v-2.55c0-1.2-.25-2.1-.76-2.66a2.55 2.55 0 0 0-2-.85c-1.78 0-2.67 1.08-2.67 3.26v2.3h-5.23v-1.85c0-2.81.7-4.97 2.06-6.47 1.41-1.5 3.42-2.26 6.03-2.26 2.65 0 4.66.75 6.03 2.26 1.38 1.47 2.06 3.6 2.06 6.42v1.25c0 1.9-.31 3.45-.95 4.62a5.44 5.44 0 0 1-2.97 2.45v.1a5.53 5.53 0 0 1 3.12 2.61c.64 1.2.95 2.75.95 4.62v3.1c0 2.82-.7 4.97-2.1 6.48-1.38 1.47-3.42 2.2-6.14 2.2Z"
		/>
		<defs>
			<filter
				id="a"
				width="134"
				height="134"
				x="0"
				y="0"
				colorInterpolationFilters="sRGB"
				filterUnits="userSpaceOnUse"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					result="hardAlpha"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="7.5" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix values="0 0 0 0 0.0901961 0 0 0 0 0.0901961 0 0 0 0 0.0901961 0 0 0 0.02 0" />
				<feBlend
					in2="BackgroundImageFix"
					result="effect1_dropShadow_35652_7867"
				/>
				<feColorMatrix
					in="SourceAlpha"
					result="hardAlpha"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
				/>
				<feMorphology
					in="SourceAlpha"
					operator="dilate"
					radius=".25"
					result="effect2_dropShadow_35652_7867"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="2" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix values="0 0 0 0 0.0901961 0 0 0 0 0.0901961 0 0 0 0 0.0901961 0 0 0 0.09 0" />
				<feBlend
					in2="effect1_dropShadow_35652_7867"
					result="effect2_dropShadow_35652_7867"
				/>
				<feBlend
					in="SourceGraphic"
					in2="effect2_dropShadow_35652_7867"
					result="shape"
				/>
			</filter>
		</defs>
	</Icon>
);
